import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { APIConstants } from '@shared/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { City } from '../models';
import { BusinessType } from '@shared-features/enums';

@Injectable({
  providedIn: 'root',
})
export class CityAPI {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getActiveCities(businessType?: BusinessType): Observable<City[]> {
    return this.baseAPI.get(APIConstants.API_GET_ACTIVE_CITIES, { params: { businessType } }).pipe(
      map((res) => {
        return this.mapper.fromJson(City, res.data);
      })
    );
  }
}
